import React, { useState, useEffect, useRef, useCallback } from 'react';


export const PLANES = {
  classic: {
    name: 'Classic Dart',
    lift: 1.0,
    drag: 1.0,
    boost: 1.0,
    color: '#f8fafc',
    description: 'Balanced all-rounder',
    cost: 0,
  },
  glider: {
    name: 'Sky Glider',
    lift: 1.4,
    drag: 0.95,
    boost: 0.8,
    color: '#60a5fa',
    description: 'Maximum glide time',
    cost: 500,
  },
  dart: {
    name: 'Speed Dart',
    lift: 0.8,
    drag: 1.1,
    boost: 1.3,
    color: '#ef4444',
    description: 'Fast but harder to control',
    cost: 750,
  },
  stealth: {
    name: 'Stealth Wing',
    lift: 1.2,
    drag: 1.0,
    boost: 1.1,
    color: '#1e293b',
    description: 'Smooth handling',
    cost: 1000,
  },
};
